export default __webpack_public_path__ + "static/media/uy.cb5fcc05.svg";